import { FormFieldMapType } from '../../@types';

import { CardFieldMap } from './CardFieldMap';
import { ContactFieldMap } from './ContactFieldMap';
import { BillingFieldMap } from './BillingFieldMap';

export const FormFieldMap: FormFieldMapType = {
  cardFields: CardFieldMap,
  contactFields: ContactFieldMap,
  billingFields: BillingFieldMap,
};
